/*jshint esnext: true */
/*global jQuery, dis */

/* DIS/PLAY Script
 Author's name: Lars Munkholm
 Modified by:
 Client name: Danske Regioner
 Date of creation: 8.3.2016
 */


(function ($, dis) {
	"use strict";


	dis.MainSearch = function (objectConfiguration) {
		dis.BaseModule.call(this);

		var defaults = {},
			configuration = $.extend(defaults, objectConfiguration),
			dom = {},
			selfScope = this;


		function init() {
			dom.container = $(configuration.container);

			if (dom.container.length) {
				dom.triggerLabel = dom.container.find("> label");
				dom.triggerLabel.attr('tabindex', 0);
				dom.triggerLabelClose = dom.triggerLabel.find(".close-icon");

				dom.searchTriggerLabel = document.querySelector('label[for="main-search__trigger"]');
				dom.searchTrigger = document.getElementById("main-search__trigger");

				dom.searchField = dom.container.find("form input");
				dom.languagePicker = $(".page-header__languages");

				var isOpen = false;


				// Open search with enter key on focus.
				dom.triggerLabel.on('focus', function () {
					$(this).on('keydown', function (e) {
						e.stopImmediatePropagation();

						if (e.which === 13 && isOpen && document.activeElement === dom.searchTriggerLabel) {

							console.log("close");
							e.preventDefault();
							selfScope.globalDOM.body.removeClass("search-open");
							dom.searchTrigger.checked = false;
							isOpen = false;
							return false;
						}

						if (e.which === 13 && !isOpen) {

							e.preventDefault();
							dom.triggerLabel.click();
						}

						if (e.which === 27 && isOpen) {
							dom.triggerLabelClose.click();
						}
					});
				});

				// Close search with escape key.
				dom.container.on('keydown', function (e) {

					if (e.which === 27 && isOpen) {
						dom.triggerLabelClose.click();
					}
				});

				// When search opens
				dom.triggerLabel.on('click', function (e) {
					e.stopPropagation();
					// Focus on search field
					setTimeout(function () {
						dom.searchField.focus();
					}, 500);

					isOpen = true;
					// Set class on body
					selfScope.globalDOM.body.addClass("search-open");
				});

				// When search closes
				dom.triggerLabelClose.click(function (e) {
					e.stopPropagation();

					// Remove focus from search field
					dom.searchField.blur();

				isOpen = false;
					// Remove class from body
					selfScope.globalDOM.body.removeClass("search-open");
				});
			}
		}

		selfScope.onReady(init);
	};

	dis.MainSearch.prototype = new dis.BaseModule();
	dis.MainSearch.constructor = dis.MainSearch;


// This is where you define the global parameters you pass into your closure. You'll want to pass in any
// big stuff you'll need inside your script. Minor stuff can always be accessed through window.someVariable.
}(jQuery, dis));
